import React from 'react';
import './OverlayLoader.scss';
import { Modal } from 'antd';

export default function OverlayLoaderModal({ isOpen }) {
    return (
        <Modal
            className='loader-modal'
            open={isOpen}
            closable={false}
            closeIcon={false}
            footer={null}
            destroyOnClose={true}
        >
            <div className='overlay-component'>
                <div className="loader"></div>
                <p className='message'>Please wait while the image is being uploaded</p>
            </div>
        </Modal >
    )
}
